import { useTranslation } from 'react-i18next';
import PublicContentPage, { PublicCtaLink } from '../components/layout/PublicContentPage';

interface MethodologySection {
  title: string;
  body: string;
  points?: string[];
}

export default function MethodologyPage() {
  const { t } = useTranslation('marketing');
  const sections = t('pages.methodology.sections', { returnObjects: true }) as MethodologySection[];
  const sidebarPoints = t('pages.methodology.sidebar.points', { returnObjects: true }) as string[];
  const ctaActions = t('pages.methodology.cta.actions', { returnObjects: true }) as Array<{
    href: string;
    label: string;
    variant: 'primary' | 'secondary' | 'ghost';
  }>;

  return (
    <PublicContentPage
      metaTitle={t('pages.methodology.meta.title')}
      metaDescription={t('pages.methodology.meta.description')}
      canonicalPath="/methodology"
      eyebrow={t('pages.methodology.hero.eyebrow')}
      title={t('pages.methodology.hero.title')}
      intro={t('pages.methodology.hero.intro')}
      aside={(
        <>
          <section className="acc-public-page-card acc-public-page-card--sticky">
            <h2>{t('pages.methodology.sidebar.title')}</h2>
            <p>{t('pages.methodology.sidebar.body')}</p>
            <ul className="acc-public-page-list">
              {sidebarPoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </section>

          <section className="acc-public-page-card">
            <h2>{t('pages.methodology.sidebar.limitsTitle')}</h2>
            <p>{t('pages.methodology.sidebar.limitsBody')}</p>
          </section>
        </>
      )}
    >
      {sections.map((section) => (
        <section key={section.title} className="acc-public-page-card">
          <h2>{section.title}</h2>
          <p>{section.body}</p>
          {section.points && section.points.length > 0 && (
            <ul className="acc-public-page-list">
              {section.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      <section className="acc-public-cta-band" aria-labelledby="methodology-cta-title">
        <div>
          <h2 id="methodology-cta-title">{t('pages.methodology.cta.title')}</h2>
          <p>{t('pages.methodology.cta.body')}</p>
        </div>
        <div className="acc-public-cta-actions">
          {ctaActions.map((action) => (
            <PublicCtaLink key={action.href} href={action.href} variant={action.variant}>
              {action.label}
            </PublicCtaLink>
          ))}
        </div>
      </section>
    </PublicContentPage>
  );
}
